import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const EyeSlashIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M15.064.936a.75.75 0 0 1 0 1.061l-2.196 2.196c.27.239.52.483.75.723a14.8 14.8 0 0 1 2 2.654l.028.05.008.014.003.004v.002s.001.001-.657.36l.658.36-.001.002-.003.004-.008.015a7 7 0 0 1-.133.227 14.815 14.815 0 0 1-1.896 2.476c-1.274 1.335-3.209 2.8-5.617 2.8-1.392 0-2.625-.49-3.664-1.16l-2.34 2.34a.75.75 0 1 1-1.06-1.06l2.196-2.197q-.405-.36-.75-.722a14.8 14.8 0 0 1-2-2.654l-.029-.05-.008-.015-.002-.004-.001-.002L1 8C.34 7.641.342 7.64.342 7.64v-.002l.003-.004.008-.014a6 6 0 0 1 .133-.228 14.802 14.802 0 0 1 1.896-2.476c1.275-1.335 3.21-2.8 5.618-2.8 1.391 0 2.625.49 3.664 1.16l2.339-2.34a.75.75 0 0 1 1.06 0m-4.49 3.43C9.79 3.91 8.926 3.616 8 3.616c-1.792 0-3.357 1.103-4.533 2.335a13.3 13.3 0 0 0-1.593 2.05q.1.162.249.379a13.3 13.3 0 0 0 1.344 1.669q.343.36.728.696zm-5.148 7.268c.783.455 1.648.75 2.574.75 1.791 0 3.357-1.103 4.532-2.335A13.3 13.3 0 0 0 14.126 8a13.31 13.31 0 0 0-1.594-2.049q-.342-.36-.727-.695zM1 8l-.658-.36a.75.75 0 0 0 0 .72zm14 0 .658.36a.75.75 0 0 0 0-.719zM8 5.95A2.05 2.05 0 0 0 5.95 8a.75.75 0 1 1-1.5 0A3.55 3.55 0 0 1 8 4.45a.75.75 0 1 1 0 1.5m2.8 1.3a.75.75 0 0 1 .75.75A3.55 3.55 0 0 1 8 11.55a.75.75 0 0 1 0-1.5A2.05 2.05 0 0 0 10.05 8a.75.75 0 0 1 .75-.75"
      clipRule="evenodd"
    />
  </svg>
);
EyeSlashIcon.id = 'EyeSlashIcon';
EyeSlashIcon.displayName = 'EyeSlashIcon';
export default EyeSlashIcon;
